import React from "react";
import { DocsSearch } from "@litonarefin/components/DocsSearch";

function TopBar({ data }) {
  return (
    <div className="jlt-hidden md:jlt-flex jlt-justify-center jlt-items-center jlt-flex-col jlt-gap-y-8 md:jlt-flex-row md:jlt-gap-y-0">
      <DocsSearch
        miniIcon={false}
        docSlug={data.slug}
        className="jlt-w-full md:jlt-w-[500px]"
      />
    </div>
  );
}

export default TopBar;
